import styles from "./RecentOrders.module.scss";
import DataTable, { Column } from "../../common/data-table/DataTable";
import { formatDate } from "../../../utils/date";
import { PaymentTypes } from "../../../api/types/order.types";
import { useEffect, useState } from "react";
import OrderService from "../../../api/services/orders.service";
import Loading from "../../common/loading/Loading";
import { useTranslation } from "react-i18next";

const StatusButton = ({ status }: { status: string }) => {
  const { t } = useTranslation("translation");
  switch (status) {
    case "1":
      return (
        <div className={styles.confirmBtn}>
          {t("payments.status.not_completed")}
        </div>
      );
    case "2":
      return (
        <div className={styles.readyBtn}>{t("payments.status.success")}</div>
      );
    case "3":
      return (
        <div className={styles.adminBtn}>{t("payments.status.failed")}</div>
      );
    default:
      return (
        <div className={styles.unknownBtn}>{t("payments.status.unknown")}</div>
      );
  }
};

const RecentOrders = () => {
  const [paymnets, setPayments] = useState<PaymentTypes[]>([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("translation");

  const getData = async () => {
    setLoading(true);
    try {
      const res = await OrderService.getAllPayments(1, 10);
      setPayments(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const columns: Column[] = [
    {
      key: "order_id",
      header: t("columns.order_id") || "Order ID",
      render: (v) => <p className={styles.box}>{v}</p>,
    },
    {
      key: "transaction_id",
      header: t("columns.transaction_id") || "Transaction ID",
      render: (v) => <p className={styles.content}>{v}</p>,
    },
    {
      key: "user",
      header: t("columns.client") || "Client",
      render: (_, row) => (
        <p className={styles.content}>
          {row?.user?.first_name} {row?.user?.last_name}
        </p>
      ),
    },
    {
      key: "amount",
      header: t("columns.amount") || "Amount",
      render: (_, row) => (
        <p>
          {row.amount}
          {row.currency_name}
        </p>
      ),
    },
    {
      key: "card_number",
      header: t("columns.card_number") || "Card Number",
    },
    {
      key: "created",
      header: t("columns.date") || "Date",
      render: (v) => formatDate(v),
    },
    {
      key: "status",
      header: t("columns.status") || "Status",
      render: (value) => {
        return <StatusButton status={value} />;
      },
    },
  ];

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.recents_orders}>
      <div className={styles.section_header}>
        <h2 className={styles.title}>{t("recent_orders")}</h2>
      </div>
      <DataTable data={paymnets} columns={columns} />
    </div>
  );
};

export default RecentOrders;
